import { POSTHOG_TRACKING_EVENTS, PosthogTrackingSource } from '../constants';
import { CaptureTrackingEvent } from './types';

export const createAssetOverviewEvents = (
  captureTrackingEvent: CaptureTrackingEvent
) => {
  const trackAssetOpen = (
    source: PosthogTrackingSource,
    entities: string[]
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.ASSET_OPEN,
      properties: { source, entities },
    });

  const trackAoDrawerOpen = (
    source: PosthogTrackingSource,
    entities: string[]
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.AO_DRAWER_OPEN,
      properties: { source, entities },
    });

  const trackConnectionsTabSelected = (
    source: PosthogTrackingSource,
    type: string,
    entities: string[]
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.CONNECTIONS_TAB_SELECTED,
      properties: { source, type, entities },
    });

  const trackAssetOverviewTabSelected = (
    source: PosthogTrackingSource,
    type: string,
    entities: string[]
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.ASSET_OVERVIEW_TAB_SELECTED,
      properties: { source, type, entities },
    });

  const trackKgBrandDrawerOpen = (
    source: PosthogTrackingSource,
    entities: string[]
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.KG_BRAND_DRAWER_OPEN,
      properties: { source, entities },
    });

  const trackKgGeographyDrawerOpen = (
    source: PosthogTrackingSource,
    type: 'country' | 'region',
    entities: string[]
  ) =>
    captureTrackingEvent({
      eventName: POSTHOG_TRACKING_EVENTS.KG_GEOGRAPHY_DRAWER_OPEN,
      properties: { source, type, entities },
    });

  return {
    trackAssetOpen,
    trackAoDrawerOpen,
    trackConnectionsTabSelected,
    trackAssetOverviewTabSelected,
    trackKgBrandDrawerOpen,
    trackKgGeographyDrawerOpen,
  };
};
